import * as React from 'react'

function Avatar (props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.6667 30.3333C23.7668 30.3333 30.3333 23.7668 30.3333 15.6667C30.3333 7.56649 23.7668 1 15.6667 1C7.56649 1 1 7.56649 1 15.6667C1 23.7668 7.56649 30.3333 15.6667 30.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6643 17.2963C18.3643 17.2963 20.5532 15.1075 20.5532 12.4074C20.5532 9.70738 18.3643 7.51855 15.6643 7.51855C12.9642 7.51855 10.7754 9.70738 10.7754 12.4074C10.7754 15.1075 12.9642 17.2963 15.6643 17.2963Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.16211 26.8279C6.56546 25.4854 7.3908 24.3088 8.5157 23.4724C9.64059 22.6361 11.0051 22.1846 12.4068 22.1851H18.9254C20.3289 22.1846 21.6951 22.6371 22.8208 23.4754C23.9465 24.3136 24.7716 25.4928 25.1734 26.8377"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Avatar
